module.exports = __webpack_public_path__ + "img/banner.c1624da1.jpg";